import { Modal, Table } from "antd";
import React from "react";

export default function EligibilityDataModal({ showEligibilityDataModal, setShowEligibilityDataModal, eligibilityData }) {
  const eligibilityDataColumns = [
    {
      title: "Procedure Code",
      dataIndex: "procedure_code",
      key: "procedure_code",
    },
    {
      title: "Procedure Name",
      dataIndex: "procedure_name",
      key: "procedure_name",
      render: (text) => (text !== "" ? text : "-"),
    },
    {
      title: "Eligible Today",
      dataIndex: "eligible_today",
      key: "eligible_today",
    },
    {
      title: "Last Verified",
      dataIndex: "last_verified",
      key: "last_verified",
    },
  ];
  return (
    <Modal open={showEligibilityDataModal} onCancel={() => setShowEligibilityDataModal(false)} title="Eligibility Data" width="75%" footer={null}>
      <Table
        columns={eligibilityDataColumns}
        dataSource={eligibilityData && eligibilityData.procedures}
        pagination={{ position: ["bottomCenter"] }}
      />
    </Modal>
  );
}
